import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/index";
import { FormContext } from "../../pages/_app";
import dynamic from "next/dynamic";

const FullPageLoader = dynamic(() =>
  import("../FullPageLoader/FullPageLoader")
);
const LetsConnect = dynamic(() => import("../modals/LetsConnect"));
const HocHead = dynamic(() => import("../HigherOrderComponent/HocHead"));

import Technology from "../technology/technology";
import TechnologyNew from "../technologies-new/technology";

const TechnologyPage = (props) => {
  const { isPreview } = props
  const slug = props.slug;

  const loading = useSelector((state) => state.loaderReducer.loading);
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const technologyFormContext = {
    showModal,
    showForm: () => setShowModal(true),
    hideForm: () => setShowModal(false),
  };

  var sdata = props.data;

  const data = sdata.data[0]?.attributes;
  const design = sdata.data[0]?.attributes?.design;
  const seo = sdata.data[0]?.attributes.seo;
  const blocks = sdata.data[0]?.attributes.blocks;

  useEffect(() => {
    dispatch(actions.hideLoader());

  }, []); //This will run only once

  function SwitchCase(props) {
    if (isPreview) {
      return <TechnologyNew {...props} />
    }

    switch (design) {
      case "new":
        return <TechnologyNew {...props} />
      default:
        return <Technology {...props} />
    }
  }

  return (
    <>
      {seo && <HocHead seo={seo} />}

      {loading && <FullPageLoader />}

      <FormContext.Provider value={technologyFormContext}>
        <SwitchCase
          blocks={blocks}
          slug={data.title}
          pageSlug={slug}
          type="Technology"
        />
      </FormContext.Provider>

      <LetsConnect show={showModal} hide={() => setShowModal(false)} />
    </>
  );
};

export default TechnologyPage;
